<template>
  <el-table
    :data="tableData"
    style="width: 100%"
    :border="border"
    header-row-class-name="headCls"
    class="table"
    height="calc(100% - -7px)"
    @cell-click="rowClick"
  >
    <el-table-column type="index" label="Number" align="center" width="80px" v-if="showNumber"></el-table-column>
    <el-table-column
      :label="item.label"
      align="center"
      v-for="(item, index) of column"
      :key="index"
    >
      <template slot-scope="scope">
        <span :title="scope.row[item.field]" class="item_data" v-html="scope.row[item.field]">{{scope.row[item.field]|| "-"}}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    column: {
      type: Array,
      default: () => []
    },

    tableData: {
      type: Array,
      default: () => []
    },

    editText: {
      type: String,
      default: ""
    },

    column200: {
      type: Boolean,
      default: false
    },

    column300: {
      type: Boolean,
      default: false
    },

    showNumber: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      border: true
    };
  },
  methods: {
    rowClick(row, column, cell, event) {
      this.$emit("rowClick", row, column, cell, event);
    },

    editRow(scope) {
      this.$emit("editTable", {
        flag: this.flag,
        scope
      });
    }
  }
};
</script>

<style scoped>
.item_data {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  vertical-align: bottom; /* overflow 会带来元素塌陷   需要设置vertical-align*/
}

.table >>> .headCls th {
  background-color: #f7f8fa !important;
}

.table >>> .headCls th > .cell {
  font-size: 13px !important;
  /* font-weight: 500; */
  color: #4e5671 !important;
}

.table >>> .el-table__header-wrapper {
  height: auto !important;
  /* margin-bottom: 5px; */
}
/**样式被其他文件覆盖  临时解决办法*/
.column200 >>> colgroup col {
  width: 200px !important;
}
.column300 >>> colgroup col {
  width: 25% !important;
}
</style>